// Badge zrodla + daty (Design AI, Menu): jeden komponent = jeden wyglad.
import { Badge } from "@/components/ui/badge";

export function AiDateBadge({ label, date, title }: { label: string; date?: string | null; title?: string }) {
  return (
    <Badge variant="outline" className="text-[10px]" title={title}>
      {label}{date ? ` · ${new Date(date).toLocaleDateString("pl-PL")}` : ""}
    </Badge>
  );
}
